import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSnackbar } from 'notistack';
import React from 'react';
import { DELETE_POST } from '../../../helpers/graphql/posts';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default function DeleteDialog({
  btnText,
  dialogText,
  setOpen,
  permlink,
  setPosts,
  posts,
  onDelete,
}) {
  const [deletePost] = useMutation(DELETE_POST);

  const { enqueueSnackbar } = useSnackbar();

  const handleSetDeleted = () => {
    if (onDelete) onDelete();
    else {
      const newPosts = [];
      posts.forEach(post => {
        if (post.permlink !== permlink) {
          newPosts.push(post);
        }
      });
      setPosts(newPosts);
    }
  };

  const handleDeleteForever = () => {
    deletePost({
      variables: {
        permlink,
      },
    })
      .then(({ data }) => {
        if (data.deletePost.success) {
          handleSetDeleted();
          setOpen(undefined);
        } else {
          enqueueSnackbar(
            `Post could not be deleted: ${data.deletePost.message}`,
            {
              variant: 'error',
            },
          );
        }
      })
      .catch(() => {
        enqueueSnackbar('Post could not be deleted', {
          variant: 'error',
        });
      });
  };

  return (
    <Dialog
      open={permlink !== undefined}
      onClose={() => setOpen(undefined)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{btnText}?</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(undefined)} color="primary">
          Cancel
        </Button>{' '}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Button
              variant="contained"
              onClick={handleDeleteForever}
              color="primary"
            >
              <DeleteForeverIcon />
              {btnText}
            </Button>
          </ThemeProvider>
        </StyledEngineProvider>
      </DialogActions>
    </Dialog>
  );
}
